/* tslint:disable */
import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import { PaginatedList } from '../../models/paginator/paginated-list';
import { NotificationModel } from '../../models/notification-model';

export interface NotificationsGetParams {
  unreadOnly?: boolean;
  pageNumber?: number;
  pageSize?: number;
}

export function notificationsGet(
  http: HttpClient,
  rootUrl: string,
  params: NotificationsGetParams,
  headers: HttpHeaders,
  context?: HttpContext,
): Observable<StrictHttpResponse<PaginatedList<NotificationModel>>> {
  const rb = new RequestBuilder(rootUrl, notificationsGet.PATH, 'get');

  for (const headerKey of headers.keys()) {
    rb.header(headerKey, headers.get(headerKey));
  }

  rb.query('unreadOnly', params.unreadOnly);
  rb.query('pageNumber', params.pageNumber);
  rb.query('pageSize', params.pageSize);

  return http
    .request(rb.build({ responseType: 'json', accept: '*/*', context }))
    .pipe(
      filter(
        (r: unknown): r is HttpResponse<unknown> => r instanceof HttpResponse,
      ),
      map((r: HttpResponse<unknown>) => {
        return r as StrictHttpResponse<PaginatedList<NotificationModel>>;
      }),
    );
}

notificationsGet.PATH = '/api/v1/notifications';
